import Navigator from "../../components/common/Navigator";
import {BoardContainer, TitleContainer,} from "../../assets/GlobalStyles";
import {useParams} from "react-router-dom";
import ScrollToTop from "../../components/common/ScrollToTop";
import CreateReports from "./CreateReports";
import CustomReports from "./CustomReports";
import ReportsPeriod from "./ReportsPeriod";
import ReportsAdver from "./ReportsAdver";
import ReportsCampaign from "./ReportsCampaign";
import ReportsPeriodHour from "./ReportsPeriodHour";

export default function Reports(){
  const params = useParams()
  return(
    <main>
      <ScrollToTop/>
      <BoardContainer>
        <TitleContainer>
          <h1>보고서</h1>
          <Navigator/>
        </TitleContainer>
        {/* 기간별보고서 */}
        {params.id === 'reportsPeriod' && <ReportsPeriod/>}
        {params.id === 'reportsPeriodHour' && <ReportsPeriodHour/>}
        {/* 광고주별보고서 */}
        {params.id === 'reportsAdver' && <ReportsAdver/>}
        {/* 캠페인별보고서 */}
        {params.id === 'reportsCampaign' && <ReportsCampaign/>}
        {params.id === 'reports' && <CreateReports/>}
        {params.id === 'customReports' && <CustomReports/>}
      </BoardContainer>
    </main>
  )
}

